export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/transports/state.js